import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'angular2-cookie/core';

@Injectable()
export class AuthService {

    private user: Observable<firebase.User>;
    private userDetails: firebase.User = null;
    authState: any = null;
    public dashboardsVisualizar: boolean;
    public resultadoColetasVisualizar: boolean;
    public controleOcorrenciasVisualizar: boolean;
    public ocorrenciaManualVisualizar: boolean;
    public baixaOcorrenciasVisualizar: boolean;
    public ocorrenciaAutomaticaVisualizar: boolean;
    public clientesVisualizar: boolean;
    public usuariosVisualizar: boolean;
    public pontoFisicoVisualizar: boolean;
    public regiaoVisualizar: boolean;
    public setorVisualizar: boolean;
    public processoVisualizar: boolean;
    public checklistVisualizar: boolean;
    public roteiroVisualizar: boolean;
    public permissaoVisualizar: boolean;
    public indicadorOperacionalVisualizar: boolean;
    public importacaoVisualizar: boolean;
    public dashboardsAlterar: boolean;
    public resultadoColetasAlterar: boolean;
    public controleOcorrenciasAlterar: boolean;
    public ocorrenciaManualAlterar: boolean;
    public baixaOcorrenciasAlterar: boolean;
    public ocorrenciaAutomaticaAlterar: boolean;
    public clientesAlterar: boolean;
    public usuariosAlterar: boolean;
    public pontoFisicoAlterar: boolean;
    public regiaoAlterar: boolean;
    public setorAlterar: boolean;
    public processoAlterar: boolean;
    public checklistAlterar: boolean;
    public roteiroAlterar: boolean;
    public permissaoAlterar: boolean;
    public indicadorOperacionalAlterar: boolean;
    public importacaoAlterar: boolean;
    public inconsistenciasVisualizar: boolean;
    public inconsistenciasAlterar: boolean;
    public reincidenciasVisualizar: boolean;
    public reincidenciasAlterar: boolean;
    public roteiroInternoVisualizar: boolean;
    public roteiroInternoAlterar: boolean;
    public isAdmin: boolean;

    constructor (private afAuth: AngularFireAuth,
        private router: Router,
        private _cookieService: CookieService) {
        this.user = afAuth.authState;
        this.user.subscribe(
            (user) => {
                if (user) {
                    this.userDetails = user;
                } else {
                    this.userDetails = null;
                }
            }
        );
    }

    isLoggedIn() {
        if (this._cookieService.get('token') === undefined) {
            return false;
        } else {
            return true;
        }
    }


    logout() {
        this._cookieService.removeAll();
        this.afAuth.auth.signOut()
            .then((res) => this.router.navigate(['/']));
    }

    get isUserAnonymousLoggedIn(): boolean {
        return (this.authState !== null) ? this.authState.isAnonymous : false;
    }

    get currentUserId(): string {
        return (this.authState !== null) ? this.authState.uid : '';
    }

    get currentUserName(): string {
        return this.authState['email'];
    }

    get currentUser(): any {
        return (this.authState !== null) ? this.authState : null;
    }

    get isUserEmailLoggedIn(): boolean {
        if ((this.authState !== null) && (!this.isUserAnonymousLoggedIn)) {
            return true;
        } else {
            return false;
        }
    }

    changePassword(email: string) {
        return this.afAuth.auth.sendPasswordResetEmail(email)
            .then((user) => {
                this.authState = user;
            })
            .catch(error => {
                console.log(error);
                throw error;
            });
    }

    signUpWithEmail(email: string, password: string) {
        return this.afAuth.auth.createUserWithEmailAndPassword(email, password)
            .then((user) => {
                this.authState = user;
            })
            .catch(error => {
                console.log(error);
                throw error;
            });
    }

    loginWithEmail(email: string, password: string) {
        return this.afAuth.auth.signInWithEmailAndPassword(email, password)
            .then((user) => {
                this.authState = user;
                this._cookieService.put('uid', JSON.parse(JSON.stringify(user.uid)));
                this._cookieService.put('token', JSON.parse(JSON.stringify(this.afAuth.auth.currentUser)).stsTokenManager.accessToken);
            })
            .catch(error => {
                console.log(error);
                throw error;
            });
    }

    signOut(): void {
        this.afAuth.auth.signOut();
        this.router.navigate(['/']);
    }

    hasSelectedCliente(): boolean {
        return this._cookieService.get('idCliente') === undefined ? false : true;
    }

    hasExpectedRole(expectedRole: string): boolean {
        const roles = JSON.parse(this._cookieService.get('roles'));
        for (const roleUsuario of roles) {
            if (roleUsuario.role === expectedRole) {
                return true;
            }
        }
        return false;
    }

    inicializarPermissoesVisualizacao() {
        this.dashboardsVisualizar = this.hasExpectedRole('DASHBOARDS_VISUALIZAR');
        this.resultadoColetasVisualizar = this.hasExpectedRole('RESULTADO_COLETAS_VISUALIZAR');
        this.controleOcorrenciasVisualizar = this.hasExpectedRole('CONTROLE_OCORRENCIAS_VISUALIZAR');
        this.ocorrenciaManualVisualizar = this.hasExpectedRole('OCORRENCIA_MANUAL_VISUALIZAR');
        this.baixaOcorrenciasVisualizar = this.hasExpectedRole('BAIXA_OCORRENCIAS_VISUALIZAR');
        this.ocorrenciaAutomaticaVisualizar = this.hasExpectedRole('OCORRENCIA_AUTOMATICA_VISUALIZAR');
        this.clientesVisualizar = this.hasExpectedRole('CLIENTES_VISUALIZAR');
        this.usuariosVisualizar = this.hasExpectedRole('USUARIOS_VISUALIZAR');
        this.pontoFisicoVisualizar = this.hasExpectedRole('PONTO_FISICO_VISUALIZAR');
        this.regiaoVisualizar = this.hasExpectedRole('REGIAO_VISUALIZAR');
        this.setorVisualizar = this.hasExpectedRole('SETOR_VISUALIZAR');
        this.processoVisualizar = this.hasExpectedRole('PROCESSO_VISUALIZAR');
        this.checklistVisualizar = this.hasExpectedRole('CHECKLIST_VISUALIZAR');
        this.roteiroVisualizar = this.hasExpectedRole('ROTEIRO_VISUALIZAR');
        this.permissaoVisualizar = this.hasExpectedRole('PERMISSAO_VISUALIZAR');
        this.indicadorOperacionalVisualizar = this.hasExpectedRole('INDICADORES_OPERACIONAIS_VISUALIZAR');
        this.importacaoVisualizar = this.hasExpectedRole('IMPORTACAO_VISUALIZAR');
        this.dashboardsAlterar = this.hasExpectedRole('DASHBOARDS_ALTERAR');
        this.resultadoColetasAlterar = this.hasExpectedRole('RESULTADO_COLETAS_ALTERAR');
        this.controleOcorrenciasAlterar = this.hasExpectedRole('CONTROLE_OCORRENCIAS_ALTERAR');
        this.ocorrenciaManualAlterar = this.hasExpectedRole('OCORRENCIA_MANUAL_ALTERAR');
        this.baixaOcorrenciasAlterar = this.hasExpectedRole('BAIXA_OCORRENCIAS_ALTERAR');
        this.ocorrenciaAutomaticaAlterar = this.hasExpectedRole('OCORRENCIA_AUTOMATICA_ALTERAR');
        this.clientesAlterar = this.hasExpectedRole('CLIENTES_ALTERAR');
        this.usuariosAlterar = this.hasExpectedRole('USUARIOS_ALTERAR');
        this.pontoFisicoAlterar = this.hasExpectedRole('PONTO_FISICO_ALTERAR');
        this.regiaoAlterar = this.hasExpectedRole('REGIAO_ALTERAR');
        this.setorAlterar = this.hasExpectedRole('SETOR_ALTERAR');
        this.processoAlterar = this.hasExpectedRole('PROCESSO_ALTERAR');
        this.checklistAlterar = this.hasExpectedRole('CHECKLIST_ALTERAR');
        this.roteiroAlterar = this.hasExpectedRole('ROTEIRO_ALTERAR');
        this.permissaoAlterar = this.hasExpectedRole('PERMISSAO_ALTERAR');
        this.indicadorOperacionalAlterar = this.hasExpectedRole('INDICADORES_OPERACIONAIS_ALTERAR');
        this.importacaoAlterar = this.hasExpectedRole('IMPORTACAO_ALTERAR');
        this.inconsistenciasVisualizar = this.hasExpectedRole('INCONSISTENCIAS_VISUALIZAR');
        this.inconsistenciasAlterar = this.hasExpectedRole('INCONSISTENCIAS_ALTERAR');
        this.reincidenciasVisualizar = this.hasExpectedRole('REINCIDENCIAS_VISUALIZAR');
        this.reincidenciasAlterar = this.hasExpectedRole('REINCIDENCIAS_ALTERAR');
        this.roteiroInternoVisualizar = this.hasExpectedRole('ROTEIRO_INTERNO_VISUALIZAR');
        this.roteiroInternoAlterar = this.hasExpectedRole('ROTEIRO_INTERNO_ALTERAR');
        this.isAdmin = this.hasExpectedRole('ADMIN');
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/auth/auth.service.ts